const ComponentTypes = `
  query {
    componentTypes
  }
  `

module.exports = {
  ComponentTypes,
}
  